// images import here
import Mark from "./assets/images/avatar-mark-webber.webp";
import Angela from "./assets/images/avatar-angela-gray.webp";
import Jacob from "./assets/images/avatar-jacob-thompson.webp";
import Rizky from "./assets/images/avatar-rizky-hasanuddin.webp";
import Kimberly from "./assets/images/avatar-kimberly-smith.webp";
import commentImage from "./assets/images/image-chess.webp";
import Nathan from "./assets/images/avatar-nathan-peterson.webp";
import Anna from "./assets/images/avatar-anna-kim.webp";
const NotificationData = [
  {
    name: "Mark Webber",
    type: "reacted",
    unread: true,
    message: {
      info: "My first tournament today",
    },
    image: Mark,
    time: "1m ago",
  },
  {
    name: "Angela Gray",
    type: "followed",
    unread: true,
    image: Angela,
    time: "5m ago",
  },
  {
    name: "Jacob Thompson",
    type: "joined_group",
    unread: true,
    message: {
      info: "Chess Club",
    },
    image: Jacob,
    time: "1 day ago",
  },
  {
    name: "Rizky Hasanuddin",
    type: "private_message",
    message: {
      info: "Hello, thanks for setting up the Chess Club. I've been a member for a few weeks now and i'm already having lots of fun and improving my game",
    },
    image: Rizky,
    time: "5 days ago",
  },
  {
    name: "Kimberly Smith",
    type: "picture_comment",
    image: Kimberly,
    commentImage,
    time: "1week ago",
  },
  {
    name: "Nathan Peterson",
    type: "reacted",
    message: {
      info: "5 end-game strategies to increase your win rate",
    },
    image: Nathan,
    time: "2 weeks ago",
  },
  {
    name: "Anna Kim",
    type: "left_group",
    message: {
      info: "Chess Club",
    },
    image: Anna,
    time: "2 weeks ago",
  },
];

export default NotificationData;
